module.exports = __webpack_public_path__ + "img/Image.e5980c3c.svg";